var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.601,
    height: 62.001,
    viewBox: "0 0 49.601 62.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M40.1,9.2H12.2V58.8H49.4V18.5H40.1ZM12.2,3h31L55.6,15.4V58.8A6.2,6.2,0,0,1,49.4,65H12.2A6.2,6.2,0,0,1,6,58.8V9.2A6.2,6.2,0,0,1,12.2,3Zm6.2,27.9H43.2v6.2H18.4Zm0,12.4H43.2v6.2H18.4Z",
    transform: "translate(-6 -3)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.eec179c31b24d14bcee656a057163b97.svg";
export { ForwardRef as ReactComponent };